import React from 'react'

const CalendarDayOutOfMonth = () => 
  <td></td>

export {CalendarDayOutOfMonth}